<template>
    <IPNav
        ref="navBarRef"
        class="text-[14px]"
        :navModuleType="NAV_MENU_TYPE.NEW_TASKS"
        :ipNavService="ipNavService"
    />
</template>

<script setup lang="ts">
import { IPNav, NAV_MENU_TYPE, createIpNavService } from '@telecom/shared/components/ip-nav';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import psHttp from '@patsnap/common-ps-http';
import { useHeaderService } from '@/presentation/composables/use-header-service';
import { useUserInfo } from '@telecom/shared/domain/permission/composables/use-user-info';
import { useCommands } from '@telecom/shared/composables/use-commands';
import { getIsOversea } from '@telecom/shared/utils/environment';
import { jumpToUsageLimitUpgradePage } from '@/features/usage-limit-modal';

const { headerService } = useHeaderService();
const navBarRef = ref<any>();
const { isLogin, isPersonalTenant, isFreeUser, isLoadingSubscription } = useUserInfo();
const { executeCommand } = useCommands();

const router = useRouter();

// // 获取所有路由的 name 集合
// const routeNames = new Set(
//     router.getRoutes()
//         .map(route => route.name)
//         .filter(name => name), // 过滤掉没有 name 的路由
// );

// 封装 psHttp 为符合 IAxiosClient 接口的对象
const httpClient = {
    get: (config: { url: string; params?: any; [key: string]: any }) =>
        psHttp({ ...config, method: 'GET' }).then(res => res.data),
    post: (config: { url: string; data?: any; [key: string]: any }) =>
        psHttp({ ...config, method: 'POST' }).then(res => res.data),
    delete: (config: { url: string; [key: string]: any }) =>
        psHttp({ ...config, method: 'DELETE' }).then(res => res.data),
};

const ipNavService = createIpNavService({
    headerService: headerService as any,
    httpClient,
    apiBaseUrl: import.meta.env.VITE_EUREKA_SERVICE_URI,
    responsive: false,
    isActive: (context) => {
        const path = context.routePath;

        // 从 router 配置中查找匹配的路由,返回其 name
        const matchedRoute = router.getRoutes().find(route => {
            // 精确匹配
            if (route.path === path) {
                return true;
            }
            // 路径包含匹配(用于子路由)
            if (path.startsWith(route.path) && route.path !== '/') {
                return true;
            }
            return false;
        });

        return matchedRoute?.name as string || null;
    },
    isShowUpgrade() {
        return isLogin.value
            && !isLoadingSubscription.value
            && isPersonalTenant.value
            && isFreeUser.value
            && getIsOversea();
    },
    onLogin: () => {
        executeCommand('login:open-dialog');
    },
    onUpgrade: () => {
        jumpToUsageLimitUpgradePage({
            trigger_source: 'side_nav',
            header_type: 'pricing_proactive_view',
            target: '_self',
        });
    },
});

// watch(isCollapsed, (collapsed) => {
//     ipNavService.toggleSidebar(!collapsed);
// }, { immediate: true });
</script>

<style scoped>
/* IP-Nav 组件自带样式,通常不需要额外样式 */
</style>
